import { render, staticRenderFns } from "./CloseModalBtn.vue?vue&type=template&id=b6cbf5ec&scoped=true&"
import script from "./CloseModalBtn.vue?vue&type=script&lang=js&"
export * from "./CloseModalBtn.vue?vue&type=script&lang=js&"
import style0 from "./CloseModalBtn.vue?vue&type=style&index=0&id=b6cbf5ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cbf5ec",
  null
  
)

export default component.exports